import React from 'react'
import './Tour.css'

const Tour = () => {
  return (
    <div>
      <div className="container">

        <div className="section-main">
          
          <h1 id="main-heading">Tour</h1><br />
          <p>Momento has been designed specifically for mobile phones to provide the best journalling experience.<br/>
            Take a tour to see how easy and enjoyable keeping a journal can be.</p>
        </div><br/><br/>

        <div id="section-2">
          <div className="row">

            <div className="col-md-6">
              <div className="section-1">
                <img src="https://i.insider.com/5a8cc0d40c89f51a008b464c?width=1200&format=jpeg" alt="" />
                <h3 class="styleheading">Capture</h3>
                <p>Momento makes it easy to privately capture the moments that matter in just a few taps; write a note, add photos and videos, tag a place and tag people.</p>
              </div>
            </div>

            <div className="col-md-6">
              <div className="section-1">
                <img src="https://petapixel.com/assets/uploads/2013/07/memories.jpg" alt="" />
                <h3 class="styleheading">Collect</h3>
                <p>Connect Momento with popular social networks and apps to automatically import your daily activities, photos, videos, updates, checkins and more!</p>
              </div>
            </div>

            <div className="col-md-6">
              <div className="section-1">
                <img src="https://cdn.vox-cdn.com/thumbor/qvJ_PVw2Ppnemy8hxFU2U3RojK0=/1400x0/filters:no_upscale()/cdn.vox-cdn.com/uploads/chorus_asset/file/23165626/memory2final.jpg" alt="" />
                <h3 class="styleheading">Remember</h3>
                <p>Scroll through a timeline of your life, browsing by days, months and years. Beautiful summaries and smart reminders spark a recollection of memories.</p>
              </div>
            </div>

            <div className="col-md-6">
              <div className="section-1">
                <img src="https://storage.googleapis.com/gweb-uniblog-publish-prod/images/SharedMemory_Google_Photo.max-1000x1000.png" alt="" />
                <h3 class="styleheading">Explore</h3>
                <p>Connect Momento with popular social networks and apps to automatically import your daily activities, photos, videos, updates, checkins and more!</p>
              </div>
            </div>

            <div className="col-md-6">
              <div className="section-1">
                <img src="https://images.squarespace-cdn.com/content/v1/5bb4cd9293a63278971faec8/1542324939792-AXFEC5RAQGIW07WX1R31/Share-Your-Stories-With-Confidence-Share-Image.jpg" alt="" />
                <h3 class="styleheading">Share</h3>
                <p>Some moments we prefer to keep private, others we like to share. Momento makes it quick and easy to share moments privately or socially.</p>
              </div>
            </div>

            <div className="col-md-6">
              <div className="section-1">
                <img src="https://www.tn.gov/content/tn/health/health-program-areas/mch-lead/for-parents/lead-safety/jcr%3Acontent/content/tn_panel/content/tn_image.img.jpg/1507654389370.jpg" alt="" />
                <h3 class="styleheading">Protect</h3>
                <p>Backup your data locally or on Cloud, protect it with a passcode and biometrics, and export it to plain text with images for use elsewhere.</p>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  )
}

export default Tour